export default {"src":"__ASTRO_ASSET_IMAGE__3fd6390e__","width":68,"height":22,"format":"svg"}